import React from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'
import Textarea from '../form/Textarea'
import ModalForm from '../common/modal-form'

import { useTranslation } from 'react-i18next'

const AccountModal = ({
    handleSubmit,
    form,
    handleInputChange,
    clearErrorField,
    errors,
    isUpdate,
    isOpen,
    setIsOpen,
}) => {
    const { t } = useTranslation()

    const groupsField = [
        {
            title: '',
            list: [
                {
                    label: 'customerInfo.username',
                    name: 'userUsername',
                    props: {
                        disabled: isUpdate,
                        required: true,
                        i18nDataError: {
                            minLength: 6,
                        },
                    },
                },
                {
                    label: 'customerInfo.password',
                    name: 'userPassword',
                    props: {
                        type: 'password',
                        required: true,
                        i18nDataError: {
                            minLength: 6,
                        },
                    },
                },
                !isUpdate && {
                    label: 'customerInfo.confirmPassword',
                    name: 'confirmPassword',
                    props: {
                        type: 'password',
                        required: true,
                        i18nDataError: {
                            minLength: 6,
                        },
                    },
                },
            ],
        },
        {
            title: t('customerInfo.contactInfo'),
            list: [
                {
                    label: 'customerInfo.firstName',
                    name: 'userName',
                    props: {
                        required: true,
                    },
                },
                {
                    label: 'customerInfo.phone',
                    name: 'userPhone',
                    props: {
                        required: true,
                        numberOnly: true,
                    },
                },
                {
                    label: 'customerInfo.email',
                    name: 'userEmail',
                    props: {
                        required: true,
                    },
                },
                {
                    label: 'customerInfo.office',
                    name: 'userOfficeName',
                    props: {
                        // required: true,
                    },
                },
            ],
        },
        // {
        //     title: t('customerInfo.address'),
        //     list: [
        //         {
        //             label: 'customerInfo.street',
        //             name: 'userStreet',
        //             props: {
        //                 required: true,
        //             },
        //         },
        //         {
        //             label: 'customerInfo.apartmentNumber',
        //             name: 'userAddressNumber',
        //             props: {
        //                 required: true,
        //             },
        //         },
        //         {
        //             label: 'customerInfo.postCode',
        //             name: 'userPostcode',
        //             props: {
        //                 required: true,
        //             },
        //         },
        //         {
        //             label: 'customerInfo.city',
        //             name: 'userCity',
        //             props: {
        //                 required: true,
        //             },
        //         },
        //         {
        //             label: 'customerInfo.floor',
        //             name: 'floor',
        //             props: {
        //                 // required: true,
        //             },
        //         },
        //         {
        //             label: 'customerInfo.address',
        //             name: 'userAddressNote',
        //             component: Textarea,
        //         },
        //     ],
        // },
    ]

    return (
        <ModalForm
            containerClass="account-modal"
            contentClass="p-0"
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
        >
            <div className="account-modal__head">
                <HeadingForm>
                    {t(
                        isUpdate
                            ? 'personalInfo.titleUpdate'
                            : 'personalInfo.titleRegister'
                    )}
                </HeadingForm>
            </div>
            <form className="container form" onSubmit={handleSubmit}>
                {groupsField.map((group, indexGroup) => (
                    <div key={indexGroup} className="food-desk-form-group">
                        {group.title && (
                            <div className="title">{group.title}</div>
                        )}
                        <div className="box-form">
                            <div className="row">
                                {group.list
                                    .filter(Boolean)
                                    .map((field, index) => {
                                        const Component =
                                            field.component || InputFill
                                        return (
                                            <div
                                                key={index}
                                                className="col-12 col-md-6"
                                            >
                                                <Component
                                                    className="mt-6"
                                                    label={t(field.label)}
                                                    name={field.name}
                                                    value={
                                                        form[field.name] ?? ''
                                                    }
                                                    error={errors[field.name]}
                                                    onChange={handleInputChange}
                                                    onFocus={() =>
                                                        clearErrorField(
                                                            field.name
                                                        )
                                                    }
                                                    inputStyle={{
                                                        borderColor: '#CDCDCD',
                                                    }}
                                                    {...field.props}
                                                />
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                ))}
            </form>
            <div className="container py-4 account-modal__footer">
                <Button onClick={handleSubmit} fullWidth>
                    {t(isUpdate ? 'button.update' : 'button.register')}
                </Button>
            </div>
        </ModalForm>
    )
}

export default AccountModal
